import {useEffect} from 'react';

import log from '@/services/logger/log';
import userBrowserService from '@/services/user/userBrowserService';
import uaUtils from '@/utils/uaUtils';

const useDeviceTypeLogger = () => {
    useEffect(() => {
        const isMobile = uaUtils.isMobile();

        if (isMobile) {
            const isIos = uaUtils.isIos();

            if (isIos) {
                log.info('Device Type: uaUtils library parsed as ios mobile');
            } else {
                log.info('Device Type: uaUtils library parsed as mobile');
            }
            return;
        }

        const isTablet = uaUtils.isTablet();

        if (isTablet) {
            log.info('Device Type: uaUtils library parsed as tablet');
            return;
        }

        const isTabletIos = userBrowserService.isTabletIos();

        if (isTabletIos) {
            log.info('Device Type: iOS tablet');
            return;
        }

        const isTabletDevice = userBrowserService.isTabletDevice();

        if (isTabletDevice) {
            log.info('Device Type: tracked as tablet');
            return;
        }

        const isDesktop = uaUtils.isDesktop();

        if (isDesktop) {
            log.info('Device Type: tracked as desktop');
            return;
        }

        log.info('Device Type: unknown');
    }, []);
};

export default useDeviceTypeLogger;
